export default function About() {
  return (
    <div className="min-h-screen bg-black py-16 px-4" dir="rtl">
      <div className="max-w-4xl mx-auto text-white">
        <h1 className="text-4xl font-black mb-8">
          عن <span className="text-red-500">برولاكس</span>
        </h1>
        <div className="space-y-6 text-neutral-300 leading-loose text-lg">
          <p>
            برولاكس هي علامة تجارية فلسطينية متخصصة في الأجهزة الكهربائية المنزلية، نقدم لكم
            أحدث التقنيات العالمية بلمسة ألمانية. نؤمن بأن المطبخ هو قلب المنزل، ولذلك نحرص
            على توفير أجهزة تجمع بين القوة، المتانة، والتصميم العصري.
          </p>
          <p>
            منذ تأسيسنا، نعمل على انتقاء أفضل المنتجات من المصانع العالمية لنضمن لعملائنا
            تجربة طهي لا تُضاهى. جميع أجهزتنا تخضع لاختبارات جودة صارمة قبل أن تصل إلى
            منزلكم.
          </p>
          <p>
            نحن نفتخر بوجود فريق دعم فني عربي متواجد على مدار الساعة لمساعدتكم في أي
            استفسار. ثقتكم هي رأس مالنا الحقيقي.
          </p>
        </div>
        <div className="mt-12 grid grid-cols-2 md:grid-cols-4 gap-6 text-center">
          {[
            { num: '+١٠٠٠', label: 'منتج' },
            { num: '+٥٠٠٠', label: 'عميل سعيد' },
            { num: '٥', label: 'سنوات ضمان' },
            { num: '٢٤/٧', label: 'دعم فني' },
          ].map((stat, i) => (
            <div key={i} className="bg-neutral-900 p-6 rounded-2xl border border-neutral-800">
              <div className="text-2xl font-black text-red-500">{stat.num}</div>
              <div className="text-neutral-400 mt-1">{stat.label}</div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}